// extracted by mini-css-extract-plugin
export default {"maincontainer":"AllBids_maincontainer__fkgHn","mybtn":"AllBids_mybtn__XzmLN"};